<template>
    <modal title="" @close="onClose">
        <video-widget :videoPackageItem="packageItem"></video-widget>
    </modal>
</template>

<script>
export default {
    name: 'modal-package',
    props: {
        code: { type: [String, Number], default: null, required: true },
    },
    data() {
        return {
            packageItem: {}
        }
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            juniorApi.get(`public/video/search/${this.code}`).then(response => {
                this.packageItem = response.data.gist;
                //this.$emit('someEvent', {});
            });
        },
        onClose() {
            this.$emit('close', {});
        }
    }
}
</script>

<style scoped>

</style>
